export enum LoggedOutGeneratorSection {
  ColorSelector = 'colorSelector',
  ScanDestination = 'scanDestination',
  ShapeSelector = 'shapeSelector',
  FrameAndText = 'frameAndText',
  Logo = 'logo',
  SignUp = 'signUp'
}
